import { getConfig } from 'config/envVars'
import BigTreeIcon from 'components/BigTreeIcon'
import * as contentStyles from '../../styles/content.module.css'
import * as styles from './treesView.module.css'
import NoSSR from 'react-no-ssr'

const config = getConfig()

const TreesView = () => <div className={contentStyles.contentView}>
  <div className={contentStyles.contentTitleRow}>
    <h1>Every card helps plant&nbsp;trees</h1>
  </div>
  <h2>Thanks to you, CardHero has helped plant 96&nbsp;trees!</h2>
  {/* <p>Our goal: plant 1000 trees this year. We’re 9.6% of the way there!</p> */}
  <br />
  <br />
  <BigTreeIcon />
  <br />
  <h2>Trees make life on earth possible. </h2>
  <p>They clean our air and water. They are habitats for wildlife and provide jobs for billions of people. At CardHero, we want to help reverse the damage that humans have done through deforestation.</p>
  <p>What we’re doing:</p>
  <div className={styles.whatWereDoing}>
    <ul>
      <li>
        <h4>We sell cards made from sustainably sourced and/or post-consumer recycled&nbsp;paper</h4>
        <p>Keep this between us, but when you’re giving a card, it’s the message that matters. The card itself is&hellip; just a piece of paper. So why would anyone cut down trees just to get that paper? Simply unnecessary.</p>
        <p>We use paper that’s sustainably-sourced or that has already been used. Perhaps you’ve heard of it? It’s called recycling.</p>
      </li>
      <li>
        <h4>We pay for trees to be planted in the Amazon and other areas devastated by&nbsp;deforestation</h4>
        <p>If we’re not cutting down trees, why are we planting more?</p>
        <ul>
          <li>Because it’s the right thing to do</li>
          <li>We benefit from what the trees produce, and</li>
          <li><i>Hmm.</i> I know there was another one. Umm... oh yeah, that’s right, without them we’d all be dead.</li>
        </ul>
        <p>So, yeah, planting a few seems cool.</p>
      </li>
    </ul>
    <div className={`${contentStyles.contentTitlePhoto} ${styles.contentPhoto}`}><img alt='Picture of Tree' src={`${config.imageHostname}plant-trees-in-the-amazon.jpg`} /></div>
  </div>
  {/* <div className={`${contentStyles.contentBodyImageFullWidth} ${styles.treeGoalTotal}`}>
    <img alt='Tree planting goals' src='https://d3br9f94aes2qf.cloudfront.net/big-tree-640.png' />
    <div className={styles.treeGoalProgress}>
      <img alt='Tree planting goals' src='https://d3br9f94aes2qf.cloudfront.net/big-tree-640.png' />
  </div>
  </div>*/}
  <p>We acknowledge that planting trees is <strong>not enough</strong> to save our planet. It is a small step. But it is a step. </p>
  <p>Thank you for helping us make it possible.</p>
  <p>- <strong>Matt</strong><br />
    <NoSSR>
      <span className={contentStyles.hidden}>- </span>matt@<span className={contentStyles.addrBit}>welcometo</span>thecardhero.com
    </NoSSR>
  </p>
</div>

export default TreesView
